module.exports = __webpack_public_path__ + "static/media/placas_antihumedad.7cb3f2c0.jpg";